
import {useRef} from 'react';
import {ChevronLeft, ChevronRight, Clock} from 'lucide-react';
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Tag} from "antd";

export const mapWeeklySchedule = (weekly_class) => {
    const dayMap = {
        saturday: 'شنبه',
        sunday: 'یکشنبه',
        monday: 'دوشنبه',
        tuesday: 'سه‌شنبه',
        wednesday: 'چهارشنبه',
        thursday: 'پنجشنبه',
        friday: 'جمعه',
    };

    const result = [
        {day: 'شنبه', classes: []},
        {day: 'یکشنبه', classes: []},
        {day: 'دوشنبه', classes: []},
        {day: 'سه‌شنبه', classes: []},
        {day: 'چهارشنبه', classes: []},
        {day: 'پنجشنبه', classes: []},
        {day: 'جمعه', classes: []},
    ];

    weekly_class?.map((item) => {
        const persianDay = dayMap[item.weekday];
        const dayObject = result.find((d) => d.day === persianDay);

        if (dayObject) {
            dayObject.classes.push({
                lesson_id: item?.lesson?.id,
                code: item?.lesson?.code,
                time: item?.start,
                end_time: item?.end,
                topic: item?.lesson?.topic?.title,
                subject: item?.lesson?.title,
            });
        }
    });

    return result;
};

export default function WeeklySchedule({dashboardData}) {
    let today = new Date().getDay() + 1;
    if (today === 7) {
        today = 0;
    }

    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = 250;
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    const schedule = mapWeeklySchedule(dashboardData?.data);

    return (
        <div className="rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-900 p-6">
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                    <Clock className="w-5 h-5 text-gray-600 dark:text-gray-300"/>
                    <h2 className="text-lg font-bold text-gray-800 dark:text-gray-100">برنامه هفتگی</h2>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        onClick={() => scroll('right')}
                        className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors"
                    >
                        <ChevronRight className="w-5 h-5"/>
                    </button>

                    <button
                        onClick={() => scroll('left')}
                        className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors"
                    >
                        <ChevronLeft className="w-5 h-5"/>
                    </button>
                </div>
            </div>

            <div
                ref={scrollRef}
                className="flex gap-3 overflow-x-auto scroll-smooth scrollbar-hide"
            >
                {schedule.map((day, index) => (
                    <div
                        key={'schedule-' + day.day + '-' + index}
                        className={`min-w-[220px] max-w-[220px] flex-shrink-0 rounded-lg p-3 transition-all duration-200 ${
                            index === today
                                ? 'border-2 border-blue-500 bg-blue-50/50 dark:bg-blue-950/20'
                                : 'border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/40'
                        }`}
                    >
                        <div className="text-center mb-3">
                            <p className={`text-sm font-semibold ${
                                index === today
                                    ? 'text-blue-600 dark:text-blue-400'
                                    : 'text-gray-700 dark:text-gray-200'
                            }`}>
                                {day.day}
                            </p>

                            {index === today && (
                                <span className="text-xs text-blue-500 dark:text-blue-400 font-medium">
                                    امروز
                                </span>
                            )}
                        </div>

                        <div className="space-y-2">
                            {day.classes.length > 0 ? (
                                day.classes.map((cls, idx) => (
                                    <Link
                                        key={cls.lesson_id + '-' + idx}
                                        to={sprintf(URLS.teacher.lessons.detail, {id: cls?.lesson_id})}
                                    >
                                        <div
                                            className={`border border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 text-xs p-2 rounded mb-2 transition-colors ${
                                                index === today
                                                    ? 'bg-white dark:bg-gray-800 shadow-sm'
                                                    : 'bg-white dark:bg-gray-800'
                                            }`}
                                        >
                                            <div className="flex flex-wrap justify-between items-center gap-1 mb-1">
                                                <Tag color="green">{cls.code}</Tag>
                                                <p className="font-semibold text-gray-700 dark:text-gray-200 mb-1">
                                                    {cls.time} - {cls.end_time}
                                                </p>
                                            </div>

                                            <p className="text-gray-700 dark:text-gray-200 leading-tight">
                                                <span>{cls.topic}</span>
                                                <span className="text-xs text-gray-500 dark:text-gray-400 block mt-1">
                                                    {cls.subject}
                                                </span>
                                            </p>
                                        </div>
                                    </Link>
                                ))
                            ) : (
                                <p className="text-xs text-gray-500 dark:text-gray-400 text-center py-2">
                                    بدون کلاس
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
